import ReducersTooling from '../../../tooling/reducersTooling';

const initialState = {
  list: ReducersTooling.initialStates.getFetchTypeInitialStateList(),
  groupsList: ReducersTooling.initialStates.getFetchTypeInitialStateList(),
  periodsList: ReducersTooling.initialStates.getFetchTypeInitialStateList(),
  calculationUnitsFilter: ReducersTooling.initialStates.getFetchTypeInitialStateList(),
  polynomialsList: ReducersTooling.initialStates.getFetchTypeInitialStateList(),
  calculationDepurationDetail: ReducersTooling.initialStates.getFetchTypeInitialState(),
  calculationDepurationDetailMetricData: ReducersTooling.initialStates.getFetchTypeInitialStateList(),
  calculationDepurationDetailExportMetricData: ReducersTooling.initialStates.getFetchTypeInitialState(),
  exportCalculations: ReducersTooling.initialStates.getFetchTypeInitialState(),
  calculationInstancesDetail: ReducersTooling.initialStates.getFetchTypeInitialStateList(),
  deleteCalculationInstance: ReducersTooling.initialStates.getFetchTypeInitialStateDelete()
};

export default initialState;



// WEBPACK FOOTER //
// ./source/client/reducers/calculationsHistory/initialState.js